import Stack from "react-bootstrap/Stack";

function ResultBodyNav({ tab, setTab }) {
  return (
    <Stack className="result-body-nav" direction="horizontal" gap={1}>
      <div
        onClick={(e) => {
          e.preventDefault();
          setTab("endpoint");
        }}
        className={tab === "endpoint" ? "nav-pill active" : "nav-pill inactive"}
      >
        <span
          className="material-symbols-rounded"
          style={{
            fontVariationSettings: "'FILL' 1",
          }}
        >
          leaderboard
        </span>{" "}
        Endpoint Sensitivity
      </div>
      <div
        onClick={(e) => {
          e.preventDefault();
          setTab("toxicity");
        }}
        className={tab === "toxicity" ? "nav-pill active" : "nav-pill inactive"}
      >
        <span className="material-symbols-rounded">genetics</span> Toxicity
        Values
      </div>
      <div
        onClick={(e) => {
          e.preventDefault();
          setTab("experiment");
        }}
        className={
          tab === "experiment" ? "nav-pill active" : "nav-pill inactive"
        }
      >
        <span
          className="material-symbols-rounded"
          style={{
            fontVariationSettings: "'FILL' 1",
          }}
        >
          biotech
        </span>
        Experimental Design
      </div>
    </Stack>
  );
}

export default ResultBodyNav;
